module.exports = __webpack_public_path__ + "assets/images/project/constituencies/aljunied-grc.jpg?v=fe44cdf0";